import { IMAGES_URL } from "../Constants/project";

export const fetchFileAndConvertToBase64 = async (file, handleConverFile) => {
  try {
    if (file?.deleted === undefined || file?.deleted === false) {
      const url = `${IMAGES_URL}/${file.path}/${file.name}`;
      const response = await fetch(url);
      const blob = await response.blob();
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = () => {
        const base64data = reader.result;
        file["data"] = base64data;
        handleConverFile(file);
      };
    }
  } catch (error) {
    console.error("Error fetching and converting file:", error);
  }
};
